import { Reveal } from "./Reveal";
import { useLanguage } from "@/i18n/LanguageContext";
import { MISSION } from "@/i18n/extra_translations";

const Manifesto = () => {
  const { t, lang } = useLanguage();
  const missionText = MISSION[lang] || MISSION.en;
  const chapters = [
    { n: "01", title: t("man_c1_t"), text: t("man_c1_x") },
    { n: "02", title: t("man_c2_t"), text: t("man_c2_x") },
    { n: "03", title: t("man_c3_t"), text: t("man_c3_x") },
  ];
  return (
    <section id="mission" className="py-28 lg:py-36" data-testid="manifesto-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <Reveal>
          <p className="text-xs tracking-[0.3em] uppercase text-[#5C7368] mb-6">{t("man_kicker")}</p>
          <h2 className="font-display font-light text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight max-w-3xl text-[#1A2F24]">
            {t("man_title_a")}<em className="text-[#5C7368]">{t("man_title_em")}</em>
          </h2>
        </Reveal>
        <Reveal delay={0.15}>
          <blockquote className="mt-10 max-w-3xl border-l-2 border-[#F4A261] pl-6 sm:pl-8" data-testid="mission-statement">
            <p className="font-display italic text-xl sm:text-2xl leading-relaxed text-[#1A2F24]">{missionText}</p>
          </blockquote>
        </Reveal>
        <div className="mt-20 grid grid-cols-12 gap-x-4 gap-y-16 md:gap-x-8">
          {chapters.map((c, i) => (
            <Reveal key={c.n} delay={i * 0.12} className="col-span-12 md:col-span-4 border-t border-[#1E352A]/15 pt-8">
              <span className="font-display text-[#F4A261] text-lg">{c.n}</span>
              <h3 className="font-display text-3xl sm:text-4xl mt-3 text-[#1A2F24]">{c.title}</h3>
              <p className="mt-4 text-sm leading-relaxed text-[#5C7368]">{c.text}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Manifesto;
